import { Brands, BrandsFN } from '../../constants/enum';

function ButtonPillBrand({brand = "", textSize = "text-base"}) {
    let br = brand.toUpperCase();
    let className = '';
    switch(br) {
        case Brands.FINELINE:
            className = 'btn-pill-brand-fineline';
            br = BrandsFN.FL
            break;            
        case Brands.DNEE:
            className = 'btn-pill-brand-dnee';
            br = BrandsFN.DN
            break;
        case Brands.BENICE:
            className = 'btn-pill-brand-benice';
            br = BrandsFN.BE
            break;
        case Brands.TROS:
            className = 'btn-pill-brand-tros';
            br = BrandsFN.TS
            break;
        case Brands.SMART:
            className = 'btn-pill-brand-smart';
            br = BrandsFN.SM
            break;
        case Brands.EVERSENSE:
            className = 'btn-pill-brand-eversense';
            br = BrandsFN.ES
            break;            
        case Brands.TOMI:
            className = 'btn-pill-brand-tomi';
            br = BrandsFN.TM
            break;
        case Brands.VIVITE:
            className = 'btn-pill-brand-vivite';
            br = BrandsFN.VV
            break;
      }
    return (
        <button className={`${className} ${textSize}`}>{br}</button>
    );
  }
  export default ButtonPillBrand;
  